export const SET_BILL_TRANSACTIONS = "SET_BILL_TRANSACTIONS";
export const RESET_BILL_REDUCER = "RESET_BILL_REDUCER";
export const SET_EDIT_DATA = "SET_EDIT_DATA";
export const RESET_EDIT_DATA = "RESET_EDIT_DATA";
export const BILL_CATEGORY = [
  { name: "Subscription", value: "Subscription" },
  { name: "Rent", value: "Rent" },
  { name: "Electricity", value: "Electricity" },
  { name: "Water", value: "Water" },
  { name: "Gas", value: "Gas" },
  { name: "Internet", value: "Internet" },
  { name: "Phone", value: "Phone" },
  { name: "Other", value: "Other" },
];
